import { api } from "./api";

export const addUserApi = (params) => {
    return api.post(`/user/create`, JSON.stringify(params));
};
export const userListApi = (params) => {
    return api.get(`/user/list`, { params });
};

export const userEditApi = (params) => {
    return api.post(`/user/edit`, JSON.stringify(params));
};

export const userDeleteApi = (params) => {
    return api.post(`/user/delete`, JSON.stringify(params));
};

export const userViewApi = (params) => {
    return api.get(`/user/view`, { params: params });
};

export const userstatusApi = (params) => {
    return api.post(`/user/change-status`, JSON.stringify(params));
};

export const uploadUsersApi = (params) => {
    return api.post(`/user/bulk-upload-users`, JSON.stringify(params));
};

export const uploadCVSFileApi = (params) => {
    return api.post(`/user/bulk-upload-csv`, params, {
        headers: { "Content-Type": "multipart/form-data" },
    });
};